import * as angular from "angular";
import * as _ from "lodash";
import template from "./diagnosticsDetail.tpl.html";

let requires = [];

export interface EquipmentDiagnosticsDetailParams {
  time: string;
  logLevel: string;
  name: string;
  message: string;
}

interface DiagnosticsDetailController extends EquipmentDiagnosticsDetailParams {
  close(): void;
}

export function openEquipmentDiagnosticsDetail(
  data: EquipmentDiagnosticsDetailParams,
  $modal: mm.foundation.modal
): angular.IPromise<any> {
  return $modal.open({
    template: template,
    controller: 'EquipmentDiagnosticsDetailCtrl as vm',
    resolve: {
      data: () => data
    }
  }).result;
}

export default angular.module('aps.controller.equipmentDiagnosticsDetail', requires)
  .controller('EquipmentDiagnosticsDetailCtrl', diagnosticsDetailCtrl)
  .name;

function diagnosticsDetailCtrl(
  data: EquipmentDiagnosticsDetailParams,
  $modalInstance: mm.foundation.modalInstance
): DiagnosticsDetailController {
  let vm = _.extend({}, data) as DiagnosticsDetailController;
  vm.close = function() {
    $modalInstance.close();
  };
  return vm;
}


// WEBPACK FOOTER //
// ./src/app/controllers/equipment/diagnosticsDetail.controller.ts